/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { Faq } from 'ui/atoms/Faq/Faq';
import { StatsBlock } from 'ui/molecules/StatsBlock/StatsBlock';

import { MsvHero } from 'landing-pages/marketplace-seller-verification/sections/MsvHero/MsvHero';
import { MsvScenarioSwitcher } from 'landing-pages/marketplace-seller-verification/sections/MsvScenarioSwitcher/MsvScenarioSwitcher';
import { MsvRegulations } from 'landing-pages/marketplace-seller-verification/sections/MsvRegulations/MsvRegulations';
import { MsvPipeline } from 'landing-pages/marketplace-seller-verification/sections/MsvPipeline/MsvPipeline';
import { MsvGraph } from 'landing-pages/marketplace-seller-verification/sections/MsvGraph/MsvGraph';
import { MsvTicker } from 'landing-pages/marketplace-seller-verification/sections/MsvTicker/MsvTicker';
import { MsvDelivery } from 'landing-pages/marketplace-seller-verification/sections/MsvDelivery/MsvDelivery';
import { MsvTestimonial } from 'landing-pages/marketplace-seller-verification/sections/MsvTestimonial/MsvTestimonial';
import { MsvFinalCta } from 'landing-pages/marketplace-seller-verification/sections/MsvFinalCta/MsvFinalCta';

import styles from './MarketplaceSellerVerificationPage.module.scss';

import { getFaqData } from './MarketplaceSellerVerificationPage.data';

export const MarketplaceSellerVerificationPage = () => {
  const { t } = useInt();

  const stats = [
    { value: '400', suffix: '+', title: t('Government registries') },
    { value: '200', suffix: '+', title: t('Countries and territories') },
    { value: '600', suffix: 'M+', title: t('Company profiles') },
    { value: '12', suffix: ' yrs', title: t('Sourcing direct from registers') },
  ];

  return (
    <div className={styles.wrapper}>
      <MsvHero />
      <StatsBlock features={stats} hasPadding={false} />
      <MsvScenarioSwitcher />
      <MsvRegulations />
      <MsvPipeline />
      <MsvGraph />
      <MsvTicker />
      <MsvDelivery />
      <MsvTestimonial />
      <MsvFinalCta />
      <Faq className={styles.faq} title={t('Questions, answered')} data={getFaqData(t)} />
    </div>
  );
};
